module.exports = __webpack_public_path__ + "img/car - 副本.a5bf12c1.png";